import React from "react";
import Context from "../../../../../Context";
import InputForm from "../../../../Misc/InputForm";
import Blocker from "../../../../Misc/Blocker";

export default class WorkflowAdd extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      loaded: false,
      item: {},
      itemsOrdered: {},
      essence: {},
    };
  }

  getChildren = (items, seekId, level) => {
    let children = {};

    Object.entries(items).forEach(([id, item]) => {
      if (String(item.parent) === seekId) {
        children[id] = { ...item, level };
        children = Object.assign(
          children,
          this.getChildren(items, id, level + 1)
        );
      }
    });

    return children;
  };

  componentDidMount() {
    this.load();
  }

  save = async (data) => {
    data.id = this.state.item["id"];
    this.setState({ pending: true });
    let result = await this.context.api.q("/workflow/class/set", data);
    if (result !== false) {
      this.context.toast("Класс сохранен", "success");
      this.props.onFinish(result);
    } else {
      this.context.toast("Не удалось сохранить класс", "error");
      this.setState({ pending: false });
    }
  };

  load = async () => {
    this.setState({ pending: true });
    let item = {};

    let essence = await this.context.api.qo("/workflow/entity/list");
    let itemsOrdered = await this.context.api.qoo("/workflow/class/list");

    let currentItem = await this.context.api.q("/workflow/class/get", {
      id: this.props.activeItem,
    });
    if (currentItem !== false) {
      item = {
        parent: currentItem["parent"],
        essence: currentItem["essence"],
      };
    }

    this.setState({
      pending: false,
      item,
      itemsOrdered,
      essence,
      loaded: true,
    });
  };

  render() {
    return (
      <>
        <div>
          <Blocker on={this.state.pending}>
            {this.state.loaded ? (
              <InputForm
                fields={{
                  parent: {
                    title: "Родитель",
                    type: "select",
                    values: this.state.itemsOrdered,
                    valuesNameKey: "label",
                    validate: true,
                    error: false,
                    default: "",
                    col: "12",
                  },
                  essence: {
                    title: "Сущность",
                    type: "select",
                    values: this.state.essence,
                    valuesNameKey: "name",
                    validate: true,
                    error: false,
                    default: "",
                    col: "12",
                  },
                  label: {
                    title: "Наименование",
                    type: "text",
                    validate: true,
                    error: false,
                    default: "",
                    col: "12",
                  },
                  code: {
                    title: "Код",
                    type: "text",
                    validate: true,
                    error: false,
                    default: "",
                    col: "12",
                  },

                  abstract: {
                    title: "Абстрактный",
                    type: "check",
                    validate: false,
                    error: false,
                    default: false,
                  },
                }}
                data={this.state.item}
                key={this.state.item["id"]}
                onSubmit={this.save}
                onCancell={this.props.onCancell}
              />
            ) : (
              <p>
                <br />
              </p>
            )}
          </Blocker>
        </div>
      </>
    );
  }
}
